import templateSearch from '../../../../../Template/config/components/selection/Search'
import searchFilter from './SearchFilter'
import tagHierarchy from './TagHierarchy'

export default {
    ...templateSearch,
    searchFilter,
    tagHierarchy
}



// WEBPACK FOOTER //
// ./src/app/configuration/Discover/config/components/selection/Search/index.js